<script lang="ts">
    import { Grabber, GrabberState } from "@utils/highlights/directive-logic/global-select-handler"
    import { blockListenerPropagation } from "@utils/highlights/directive-logic/selection-logic"
    import type { WordSelectionBar } from "@utils/highlights/directive-logic/wordbox"
    import { createEventDispatcher } from "svelte"
    import { fade } from "svelte/transition"

    export let grabberState : GrabberState
    export let grabber: Grabber
    export let offsetLeft: number
    export let offsetTop: number
    export let coordinates: WordSelectionBar

    const dispatch = createEventDispatcher<{
        "move": {clientX : number, clientY : number}
        "done": {}
        "start": {}
    }>()

    let pointerdown = false
    function handlePointerDown(event: PointerEvent) {
        event.preventDefault()
        event.stopPropagation()
        pointerdown = true
        dispatch("start")
    }

    function handlePointerUp() {
        if (pointerdown === true) {
            dispatch("done")
            pointerdown = false
        }
    }

    const Y_OFFSET = 20

    function handlePointerMove({clientX, clientY} : PointerEvent) {
        if (pointerdown == false) return
        dispatch("move", {clientX, clientY: clientY - Y_OFFSET})
    }

</script>

<svelte:window on:pointermove={handlePointerMove} on:pointerup={handlePointerUp} on:pointercancel={handlePointerUp} />

<div
    class="absolute bg-none z-1 w-0 left-0 top-0 rounded-full transition {blockListenerPropagation} {grabberState === GrabberState.MOVING ? "opacity-0 pointer-events-none" : "pointer-events-auto"}"
    transition:fade|global={{duration: 100}}
    style:translate="{coordinates.x + offsetLeft}px {coordinates.y + offsetTop}px"
    style:height="{coordinates.height}px"
>
    <div
        on:pointerdown={handlePointerDown}
        class="bg-martinique rounded-full h-8 w-8 absolute bottom-0 translate-y-full rounded-tl-none {grabber === Grabber.LEFT ? "right-0 rotate-90" : "left-0"}"
    />
</div>
